module.exports = __webpack_public_path__ + "static/media/photo_006.ea0a0887.JPG";